module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 61
// module chunks = 0